import React from "react";
import propTypes from "prop-types";
import { Category } from "../../../../logic/api";
import styles from "./styles";

 
import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";
 
import flex from "../../../../styles/flex";
import { IconButton } from "@mui/material";
import { FiEdit } from "react-icons/fi";

const DistributionCategoryListItem: React.FunctionComponent<{
    item: Category,
    selected:boolean,
    onClick: () => void,
    onEdit: () => void,
   
}> = (props) => {
    const border = props.selected ?  styles.borderSelected : styles.border


    return (
        <div style={{ ...styles.listItem, ...border }} >
            <div style={styles.listItemFlex}>

                <ListViewItemCard

                    text={props.item.categoryName}

                    onClick={() => {
                        props.onClick();
                    }}
                />


                <div style={flex.flexAuto} onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onEdit();
                    return false;
                }}>
                    <IconButton>
                        <FiEdit />
                    </IconButton>
                </div>


            </div>
        </div>
    );
}


DistributionCategoryListItem.propTypes = {
    item: propTypes.any.isRequired,
    selected:propTypes.bool.isRequired,
    onClick: propTypes.func.isRequired,
    onEdit: propTypes.func.isRequired,
};


export default DistributionCategoryListItem;